// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"365":"ae5e55ac","488":"b884471f","606":"f27b0389"}[chunkId] + ".chunk.js";
};